import css from 'styled-jsx/css'
import { colors, measurements } from 'theme'

export default css`
  .base-drawer-container {
    display: none;
    transition: all 0.1s;
  }

  .base-drawer-container.is-open {
    height: 100%;
    width: 100%;

    display: flex;
    justify-content: flex-end;
    align-items: center;

    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    z-index: 1000;

    animation: showdrawer 0.2s forwards ease-in;
  }

  @keyframes showdrawer {
    100% {
      background-color: ${colors.alpha(colors.footerBg, 0.9)};
    }
  }

  .base-drawer-container .content {
    transform: translate(200%);
    transition: all 0.3s;
    position: relative;
  }

  .base-drawer-container.is-open .content {
    width: 30%;
    max-width: 22rem;
    height: 100%;
    overflow-y: scroll;

    background-color: ${colors.white};
    color: ${colors.text};
    border-radius: ${measurements.borderRadius} 0 0 ${measurements.borderRadius};
    opacity: 1;
    animation: enterContent 0.2s forwards ease-in;
  }

  .base-drawer-container .content :global(.close-button) {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    padding: 1rem 0.5rem 1rem 1rem;
  }

  @keyframes enterContent {
    100% {
      transform: translate(0%);
    }
  }

  @media screen and (max-width: 992px) {
    .base-drawer-container.is-open .content {
      width: 100%;
    }
  }
`
